/**
 * 스크롤 단서 — 스크롤 상자마다 "지금 어디까지 왔는가" 를 DOM 에 적는다.
 *
 * 왜 있나 (2026-09-07 사용자 실보고 — "모바일로 하는 친구들은 스크롤이 안된다고 느끼는
 * 상황이 많아 보임"): 폰에는 스크롤바가 없다. 패널의 목록 상자가 짧게 잘려 있으면
 * (가방에서 칸을 고른 뒤 목록이 한 줄 반) 사람은 그 끝을 화면의 끝으로 읽고 스크롤을
 * 시도조차 안 한다. 상자 자체는 멀쩡히 스크롤되는데 **단서가 없어서** 안 되는 것처럼 느낀다.
 *
 * 무엇을 하나: `#pbody` · `.scroller` · `.act` 에 `data-scroll="top|mid|end|none"` 을 붙인다.
 * 그림(아래 페이드·"▼ 더 있음"·위 그림자)은 index.html 의 `── 스크롤 단서 ──` CSS 가 그린다.
 * 값의 뜻 — none: 넘치지 않는다 / top: 맨 위(아래에 더 있다) / mid: 중간 / end: 끝.
 *
 * ⚠ 스크롤 이벤트는 버블링하지 않는다 — `#pbody` 에 capture 로 걸어야 안쪽 상자까지 받는다.
 * ⚠ 패널을 다시 그리면 상자가 통째로 새 DOM 이라, 그린 직후 `markScrollCues()` 를 불러야 한다
 *    (panels/index.js 의 render 가 innerHTML 뒤에 부른다).
 */
import { $ } from '../core/state.js';

/** 표식을 받는 상자 — index.html 의 단서 CSS 선택자와 같은 셋이어야 한다. */
const BOXES = '#pbody, #pbody .scroller, #pbody .act';

function mark(el) {
  const more = el.scrollHeight - el.clientHeight;
  let v = 'none';
  if (more > 1) v = el.scrollTop <= 1 ? 'top' : el.scrollTop >= more - 1 ? 'end' : 'mid';
  if (el.dataset.scroll !== v) el.dataset.scroll = v;
}

/** `root` 아래(자기 자신 포함)의 스크롤 상자 전부에 표식을 다시 붙인다. */
export function markScrollCues(root) {
  const boxes = root.matches(BOXES) ? [root] : [];
  boxes.push(...root.querySelectorAll(BOXES));
  for (const el of boxes) mark(el);
}

/**
 * 한 번만. 패널 본문에 capture 리스너를 걸고, 크기가 바뀔 때마다 전부 다시 잰다.
 * Q276 — 창 위 탭 줄(#tabs, 넘치면 끝이 흐려지던 13칸)은 없앴다. 늘 보이는 다섯 칸과 메뉴 한 화면이 그 일을 한다.
 */
export function initScrollCue() {
  const pbody = $('#pbody');
  if (!pbody) return;
  pbody.addEventListener('scroll', (e) => {
    if (e.target instanceof Element) mark(e.target);
  }, { capture: true, passive: true });
  const all = () => markScrollCues(pbody);
  // 뷰포트(키보드·주소창)나 패널 크기가 바뀌면 같은 내용도 넘침 여부가 달라진다.
  new ResizeObserver(all).observe(pbody);
  addEventListener('resize', all);
  // 그림·글꼴이 늦게 도착해 내용 높이가 뒤늦게 자라는 경우 — load 는 버블링하지 않으니 capture.
  pbody.addEventListener('load', all, true);
  all();
}
